import { render, staticRenderFns } from "./StepPayment.vue?vue&type=template&id=306304ae&scoped=true"
import script from "./StepPayment.vue?vue&type=script&lang=js"
export * from "./StepPayment.vue?vue&type=script&lang=js"
import style0 from "./StepPayment.vue?vue&type=style&index=0&id=306304ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306304ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306304ae')) {
      api.createRecord('306304ae', component.options)
    } else {
      api.reload('306304ae', component.options)
    }
    module.hot.accept("./StepPayment.vue?vue&type=template&id=306304ae&scoped=true", function () {
      api.rerender('306304ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/steps/StepPayment.vue"
export default component.exports